import axios from "@/config/httpConfig";
// 解决关闭错误信息
export function operationErrorInfo(data) {
    return axios.post('/KnowledgeArticle/operationErrorInfo', data)
  }
  